import { MDBBtn, MDBBtnGroup, MDBCol, MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow, MDBTypography } from 'mdbreact';
import React from 'react';
import { Language } from '../../../redux/store/base/language';
import { useSelector } from 'react-redux';

// Import asset
import "./Info.scss";
import Fake from "./../../../assets/images/back/b-srevice.png";
import { link } from 'fs';


const Info = (props: InfoProps) => {

    const dictionary = useSelector(
        (state: { lang: Language }) => state.lang.dictionary
    );

    return <MDBContainer className="info mt-5">
        <MDBRow start middle>
            <MDBCol size="12">
                <h5>
                    {dictionary?.link?.offers}
                </h5>
            </MDBCol>
            <MDBCol size="12">
                <MDBContainer>
                    <MDBRow start middle>
                        {
                            Array.apply(null, { length: 9 }).map(() =>
                                <MDBCol className="item" md="3" sm="6" xs="12">
                                    <img src={Fake} />
                                    <div className="info">
                                        <h6 className="title">
                                            عرض العروس
                                    </h6>
                                        <p className="price">
                                            1250 ريال
                                    </p>
                                    </div>
                                    <div className="btn-link">
                                        <MDBBtn>
                                            {dictionary?.share?.request_now_female}
                                        </MDBBtn>
                                    </div>
                                </MDBCol>
                            )
                        }
                    </MDBRow>
                </MDBContainer>
            </MDBCol>
        </MDBRow>
    </MDBContainer>
};

interface InfoProps { }
export default Info;